/**
 * Glowing Pill Button for Verify Tool
 * Opens /verify in a new tab with pulsing animation
 */

import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const VerifyPillButton = ({ darkMode }) => {
  const handleClick = () => {
    window.open('/verify', '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      className="relative w-full group"
    >
      {/* Animated glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 rounded-full blur-md opacity-75 group-hover:opacity-100 animate-pulse"></div>
      
      {/* Button content */}
      <div className={`
        relative flex items-center justify-center gap-2 px-4 py-3 rounded-full
        bg-gradient-to-r from-blue-600 to-purple-600
        text-white font-semibold text-sm
        transition-all duration-300
        group-hover:shadow-lg group-hover:scale-105
        ${darkMode ? 'shadow-lg' : 'shadow-md'}
      `}>
        <ShieldCheckIcon className="w-5 h-5" />
        <span>Verify</span>
        <svg 
          className="w-4 h-4 opacity-75" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
          />
        </svg>
      </div>
    </button>
  );
};

export default VerifyPillButton;

